"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  BLUE: 'blue',
  WHITE: 'white'
};
exports.default = _default;